import { useCallback } from 'react';
import type { ClientProductEvent } from '@daevio/shared';
import { useApiClient } from './api.ts';

/** Records a dashboard event (launch metrics); never in the way of the page. */
export function useProductEvent() {
  const api = useApiClient();
  return useCallback(
    (name: ClientProductEvent, projectId?: string, props?: Record<string, string | number | boolean>) => {
      void api('/events', { method: 'POST', body: JSON.stringify({ name, projectId, props }) }).catch(() => undefined);
    },
    [api],
  );
}
